import { CircularProgress } from '@mui/material';

const Loader = () => (
  <CircularProgress color="primary" sx={{ position: 'absolute', inset: 0, margin: 'auto' }} />
);

export default Loader;
